import Link from 'next/link';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

interface SidebarGroupActionsProps {
  browseLabel?: string;
}

const SidebarGroupActions = ({ browseLabel = 'Browse Groups' }: SidebarGroupActionsProps) => (
  <>
    <ListItemButton component={Link} href="/groups" dense>
      <ListItemText
        primary={browseLabel}
        slotProps={{ primary: { variant: 'body2', color: 'primary' } }}
      />
    </ListItemButton>
    <ListItemButton component={Link} href="/groups/new" dense>
      <ListItemText
        primary="Create Group"
        slotProps={{ primary: { variant: 'body2', color: 'primary' } }}
      />
    </ListItemButton>
  </>
);

export default SidebarGroupActions;
